module.exports = __webpack_public_path__ + "img/43200.c951e472.jpg";